import { CivilStateModel } from "src/app/pages/people/models/civil-state.model";
import { AddressModel } from "./address.model";
import { AuthModel } from "./auth.model";
import { DocumentsModel } from "./documents.model";
import { SocialNetworksModel } from "./social-networks.model";
import { Router } from "@angular/router";

export class Contract {
  id?: string;
  bundle: BundleModel;
  businessPartner: string[];
  active: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  code?: string;
  token: string;
}
export interface BundleModel {
  products: ProductModel[];
  title: string;
}

export interface ProductModel {
  name: string;
  code: string;
}

export interface AttachmentsInfo {
  file: string;
  createdAt?: string;
}

export class UserModel extends AuthModel {
  socialname: string;
  fullname: string;
  email: string;
  pic: string;
  cpf: string;
  Uid: string;
  hasCPF?: boolean;
  sexo: string;
  rg: string;
  rgExpedition: string;
  birthdate: string;
  lastname?: string;
  nacionality: string;
  occupation: string;
  companyName: string;
  iduser: number;
  level: number;
  allowProducts: string[];
  attachmentsInfo: AttachmentsInfo[];
  paidStaff: string;
  phone: string;
  fatherName: string;
  isFatherAlive: boolean;
  motherName: string;
  isMotherAlive: boolean;
  address?: AddressModel;
  documents?: DocumentsModel;
  civilState?: CivilStateModel;
  socialNetworks?: SocialNetworksModel;
  successDateVital?: string;
  successDate?: string;
  finishStepOne?: boolean;
  finishStepOneVital?: boolean;
  requestUpdate?: boolean;
  stepFour?: RequestUpdateModel[];
  lastLogin?: string;
  createdAt?: string;
  Annotations?: string;
  Abroad?: boolean;
  IsForeigner?: boolean = false;
  // personal information
  firstname: string;
  username?: string;
  website: string;
  acceptedTerm?: boolean;
  acceptedTermVital?: boolean;
  Reports?: string;
  authorizeDownload?: boolean;
  authorizeDownloadVital?: boolean;
  envType?: string;
  // account information
  password: string;
  language: string;
  status?: string;
  company?: string;
  guardianID: string;
  contract: Contract;

  setUser(user: any) {
    this.Uid = user.Uid;
    this.id = user.id;
    this.level = user.level;
    this.socialname = user.socialname || "";
    this.fullname = user.fullname || "";
    this.firstname = user.firstname || "";
    this.lastname = user.lastname || "";
    this.email = user.email || "";
    this.sexo = user.gender || "";
    this.pic = user.pic || "./assets/media/users/default.jpg";
    this.cpf = user.cpf || "";
    this.hasCPF = user.hasCPF || false;
    this.rg = user.rg || "";
    this.birthdate = user.birthdate || "";
    this.paidStaff = user.paidStaff || "";
    this.phone = user.phone || "";
    this.motherName = user.motherName || "";
    this.fatherName = user.phfatherNameone || "";
    this.address = user.address || new AddressModel();
    this.documents = user.documents || new DocumentsModel();
    this.socialNetworks = user.socialNetworks;
    this.acceptedTerm = user.acceptedTerm;
    this.password = user.password || "";
    this.successDate = user.successDate || "";
    this.successDateVital = user.successDateVital || "";
    this.finishStepOne = user.finishStepOne || user.finishStepOne;
    this.finishStepOneVital = user.finishStepOneVital || user.finishStepOneVital;
    this.requestUpdate = !!user.requestUpdate?.find(
      (el) =>{
        return el.active && el.productType === user.envType}
    ).active;
    this.Annotations = user.Annotations || "";
    this.status = user.status || "";
    this.envType = user.envType;
    this.IsForeigner = user.IsForeigner;
    this.company = user.company;
    this.contract = user.contract;
    this.guardianID = user?.guardianID;
    this.allowProducts = user?.allowProducts || [];
    this.attachmentsInfo = user?.attachmentsInfo || [];
  }
}

export const TESTAMENT_TYPE: {
  TV: string;
  TP: string;
  SI: string;
  AP: string;
} = {
  TV: "VITAL",
  TP: "PARTICULAR",
  SI: "INVENTORY",
  AP: "APOIO_PERDA",
};

export type RequestUpdateModel = {
  productType: string;
  createdAt: string;
  active: string;
};

export const discriminatorEnv = (route?: string, router?: Router) => {
  if (router) {
    router.navigate([route || "/home"]);
  } else {
    window.location.href = route || "/home";
  }
};
